const {
  GET_TRANSLATIONS,
  GET_TRANSLATIONS_ERRORS,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_TRANSLATIONS:
      return {
        ...state,
        data: payload,
        loading: false,
        error: null,
      };
    case GET_TRANSLATIONS_ERRORS:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
